/* 🤖 this file was generated by svg-to-ts */
export const iconAzk: {
  name: 'azk';
  data: string;
} = {
  name: 'azk',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15" stroke="currentColor" stroke-width="2"/><g clip-path="url(#azk__circleClip)"><g style="transform:scale(.8125);transform-origin:50% 50%"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-5.11 22.81L4.08 16l6.81-6.81v3.4h6.81l-6.81 5.11zm10.22 0v-3.4H14.3l6.81-5.11V9.19L27.92 16z"/></g></g><defs><clipPath id="azk__circleClip"><circle cx="16" cy="16" r="13"/></clipPath></defs></svg>`,
};
